import { ChildrenItem } from "dependencies/base"
import { Anchor } from "./model"
import { home, appHome } from "./diffrence_options"

export let anchor_children = []
export let bs_anchor_children = []
export let app_anchor_children = []
let icon = "icon-portal-icon_line"
let cover = [require("../assets/images/anchor1.png"), require("../assets/images/anchor2.png")]
for (let i = 0; i < home.length; i++) {
  anchor_children.push(new ChildrenItem(home[i].name, icon, "cxAnchorComponent", new Anchor(home[i]), cover[i]))
}
for (let i = 0; i < appHome.length; i++) {
  app_anchor_children.push(new ChildrenItem("竖向样式", icon, "cxAnchorComponent", new Anchor(appHome[i]), cover[i]))
}
